import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pagination, Response } from '@ui/src';
import { exchangeAutoSettingsApi } from '../services';
import { AutoExchangeSettings } from '../../types';

export interface AutoSettingsListState {
  autoSettings?: AutoExchangeSettings[];
  pagination?: Pagination;
}

const initialState: AutoSettingsListState = {};

export const autoSettingsListSlice = createSlice({
  name: 'autoSettings',
  initialState,
  reducers: {
    clearAutoSettingsListState: (state) => {
      state.autoSettings = undefined;
      state.pagination = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      exchangeAutoSettingsApi.endpoints.getExchangeAutoSettings.matchFulfilled,
      (state, action: PayloadAction<Response<AutoExchangeSettings>>) => {
        state.autoSettings = action.payload.data.edges.map((item) => ({
          ...item.node,
        }));

        state.pagination = action.payload.data.pageInfo;
      },
    );
    builder.addMatcher(
      exchangeAutoSettingsApi.endpoints.changeSettingsStatus.matchFulfilled,
      (state, action: PayloadAction<{ data: AutoExchangeSettings }>) => {
        state.autoSettings = state.autoSettings?.map((item) => {
          const result = { ...item };

          if (result.id === action.payload.data.id) {
            result.active = action.payload.data.active;
          }

          return result;
        });
      },
    );
    builder.addMatcher(
      exchangeAutoSettingsApi.endpoints.updateExchangeAutoSettingsPair
        .matchFulfilled,
      (state, action: PayloadAction<{ data: AutoExchangeSettings }>) => {
        state.autoSettings = state.autoSettings?.map((item) => {
          let result = { ...item };

          if (result.id === action.payload.data.id) {
            result = action.payload.data;
          }

          return result;
        });
      },
    );
  },
});

export const { clearAutoSettingsListState } = autoSettingsListSlice.actions;

export default autoSettingsListSlice.reducer;
